<template>
  <div class="base-dropdown" ref="dropdownContainer">
    <button
      class="dropdown-trigger"
      @click.stop="toggleDropdown"
      :disabled="disabled"
    >
      <span
        class="trigger-text"
        :class="{ 'table-style': tableStyle }"
      >
        {{ triggerText }}
      </span>
      <span
        class="trigger-arrow"
        :class="{ 'table-style': tableStyle, open: isOpen }"
      >
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
          <path
            d="M1 1L6 6L11 1"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </span>
    </button>

    <transition name="dropdown">
      <div v-if="isOpen" class="dropdown-menu" @click.stop>
        <button
          v-for="(item, index) in items"
          :key="item.id || index"
          class="dropdown-item"
          :class="{ 'danger-btn': item.isDanger }"
          @click="handleItemClick(item)"
        >
          {{ item.label }}
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "BaseDropdownButton",
  props: {
    // Текст на кнопке-триггере
    triggerText: {
      type: String,
      required: true,
    },

    // Массив элементов меню
    items: {
      type: Array,
      required: true,
      validator: (items) => {
        return items.every(
          (item) => item && typeof item === "object" && item.label
        );
      },
    },

    // Отключение dropdown
    disabled: {
      type: Boolean,
      default: false,
    },

    // Стиль для таблиц
    tableStyle: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["item-click"],

  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    toggleDropdown() {
      if (this.disabled) return;
      this.isOpen = !this.isOpen;
    },

    handleClickOutside(event) {
      if (
        this.$refs.dropdownContainer &&
        !this.$refs.dropdownContainer.contains(event.target)
      ) {
        this.isOpen = false;
      }
    },

    handleItemClick(item) {
      this.$emit("item-click", item);

      if (item.action && typeof item.action === "function") {
        item.action();
      }

      this.isOpen = false;
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.base-dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-trigger {
  display: flex;
  align-items: stretch;
  height: 32px;
  min-height: 32px;
  padding: 0;
  border: none;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: none;
  box-sizing: border-box;
  transition: all 0.3s ease;
}

.dropdown-trigger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.trigger-text {
  text-align: center;
  align-content: center;
  height: 32px;
  padding: 0 10px;
  background-color: #fff;
  color: var(--color-dark);
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  border: 1px solid var(--color-green);
  border-right: none;
  border-radius: 8px 0 0 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.trigger-text.table-style {
  border-color: var(--color-dark);
}

.trigger-arrow {
  height: 32px;
  min-width: 32px;
  padding: 0 10px;
  background-color: var(--color-green);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 8px 8px 0;
  box-sizing: border-box;
  transition: transform 0.3s ease;
}

.trigger-arrow.table-style {
  background-color: var(--color-dark);
}

.trigger-arrow.open svg {
  transform: rotate(180deg);
}

.trigger-arrow svg {
  transition: transform 0.3s ease;
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.3s ease;
  transform-origin: top center;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px) scale(0.95);
}

.dropdown-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 5px);
  background-color: #fff;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 100;
  border-radius: 8px;
  overflow: hidden;
}

.dropdown-item {
  width: 100%;
  padding: 12px 16px;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  color: #333;
  transition: background-color 0.3s;
  font-size: 14px;
}

.dropdown-item:hover {
  background-color: var(--color-grey);
}

.dropdown-item:not(:last-child) {
  border-bottom: 1px solid #d1cccc;
}

.danger-btn:hover {
  background-color: var(--color-danger);
  color: #fff;
}
</style>
